/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Label } from 'reactstrap';
import { object } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import validations from '../../validations/yupValidations';
import EmailInput from '../EmailBox/EmailBox';
import TextInput from '../TextField/TextField';
import PasswordField from '../PasswordField/PasswordField';
import PhoneNumberInput from '../PhoneNumberBox/PhoneNumberBox';
import SelectBox from '../SelectBox/SelectBox';
import DatePickerComponent from '../DatePicker/DatePicker';
import CheckBoxField from '../CheckBox/CheckBox';

import { REACT_APP_API_ROLES_DROPDOWN } from '../../redux/apiConstants';
import { TableContext } from '../../contexts/tableContext';
import styles from './formValidations.module.scss';
import CustomFileUpload from '../CustomFileUpload/CustomFileUpload';

export default function FormValidations() {
  const { bodyStyle, dashboardStyle, formthemeStyle } = useContext(TableContext);
  const [roles, setRoles] = useState([]);
  const [state, setState] = useState({ isSubmitting: false });
  const formSchema = object().shape({
    name: validations.name,
    email: validations.email,
    password: validations.password,
    role: validations.role,
    phoneNumber: validations.phoneNumber,
    dateOfBirth: validations.dateOfBirth,
    agree: validations.agree,
    fileInput: validations.fileInput,
  });

  const {
    control,
    register,
    setValue,
    reset,
    trigger,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const onSubmit = () => {
    setState({ ...state, isSubmitting: true });
    new Promise((resolve) => {
      setTimeout(resolve, 5000);
    }).then(() => {
      toast.success('Success');
      setState({ ...state, isSubmitting: false });
      // reset();
    });
    // console.log(data, 'check form data');
  };

  const handleFilesChange = (files) => {
    setValue('fileInput', files);
  };

  useEffect(() => {
    const url = REACT_APP_API_ROLES_DROPDOWN;
    fetch(url)
      .then((resp) => resp.json())
      .then((resp) => setRoles(resp.data.role.selectdata));
  }, []);

  return (
    <div className={styles[bodyStyle]}>
      <div
        className={`${styles.dashboardContain} ${styles[dashboardStyle]}`}
        id={styles.dashboardcont2}
      >
        <form className="form_wrapper" onSubmit={handleSubmit(onSubmit)}>
          <div className="form_head">
            <div>
              <input
                className={`${styles.resetbtn} resetBtn mr-1`}
                type="button"
                value="Reset"
                onClick={() => {
                  reset();
                }}
              />
              <span className="sub_btn">
                <input
                  className={styles.formbtn}
                  type="submit"
                  disabled={state.isSubmitting}
                  value="Submit"
                />
              </span>
            </div>
          </div>

          <div className={`${styles[formthemeStyle]} form_container`} id={styles.addform}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <TextInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Name"
                    fieldName="name"
                    placeHolder="Enter Name"
                    register={register}
                    errors={errors}
                    isRequired
                    mandatory
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <EmailInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Email"
                    placeHolder="Enter Email Address"
                    fieldName="email"
                    register={register}
                    errors={errors}
                    isRequired
                    mandatory
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <PasswordField
                    fieldName="password"
                    className={`${styles.inputbox} text-2xl tracking-widest`}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Password"
                    register={register}
                    errors={errors}
                    placeHolder="Enter Password"
                    isRequired
                    minimLength={8}
                    eyeiconstyle={styles.eyeicon}
                    mandatory
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 selectDrp">
                  <SelectBox
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    name="role"
                    label="Role"
                    labelstyle={styles.formlabel}
                    control={control}
                    register={register}
                    values={roles}
                    errors={errors}
                    placeholder="Choose Role"
                    mandatory
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <PhoneNumberInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Phone Number"
                    placeHolder="Phone Number"
                    fieldName="phoneNumber"
                    register={register}
                    errors={errors}
                    mandatory
                    isRequired
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 dateRange">
                  <Label className={styles.formlabel}>Date of Birth</Label>
                  <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
                  <DatePickerComponent
                    className={styles.dateinputbox}
                    classNamedark={styles.dateinputbox1}
                    control={control}
                    name="dateOfBirth"
                    isRequired
                    errors={errors}
                    label="Date Of Birth"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <Controller
                    name="fileInput"
                    control={control}
                    defaultValue={[]}
                    render={({ field }) => (
                      <CustomFileUpload
                        isMultiple
                        errors={errors.fileInput}
                        onFilesChange={handleFilesChange}
                        trigger={trigger}
                        {...field}
                      />
                    )}
                  />
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <CheckBoxField
                    className={styles.inputbox}
                    fieldName="agree"
                    label="Agree"
                    labelstyle={styles.formlabel}
                    register={register}
                    errors={errors}
                    isRequired
                    mandatory
                  />
                </div>
              </div>

              <br />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
